"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalListFormat = LocalListFormat;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireDefault(require("react"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

function LocalListFormat(params) {
  var value = params.value;
  var localList = params.colDef.localList;

  if ((0, _isNil["default"])(value) || (0, _isEmpty["default"])(localList)) {
    return '';
  }

  var result = localList.find(function (item) {
    return item.id === value;
  });

  if (result) {
    return /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: result.displayName
    });
  } else {
    return null;
  }
}